import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {ReplaySubject} from 'rxjs';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {FormHelperService} from '../../../shared/services/form-helper.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {takeUntil} from 'rxjs/operators';
import {HttpErrorResponse} from '@angular/common/http';
import {PartnerService} from '../../../shared/services/partner.service';
import {Partner} from '../../../shared/interface/partner';
import {Uuid} from "../../../shared/interface/response/uuid";
import {JobResultDialogComponent} from "../../../shared/components/job-result-dialog/job-result-dialog.component";

export interface ChangeRegionalDialogData {
  partnerObject: Partner;
}

@Component({
  selector: 'app-change-regional-dialog',
  templateUrl: './change-regional-dialog.component.html',
  styleUrls: ['./change-regional-dialog.component.scss']
})
export class ChangeRegionalDialogComponent implements OnInit, OnDestroy {

  changeRegionalForm: FormGroup;
  changeAssetsRegionalControl: FormControl;
  changeLifeRegionalControl: FormControl;
  assetsRegionalControl: FormControl;
  lifeRegionalControl: FormControl;
  changeOfwcaControl: FormControl;
  changeOfwcaIfNotSameControl: FormControl;
  partnerObject: Partner;
  formErrors = {};
  processingRequest = false;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    public dialogRef: MatDialogRef<ChangeRegionalDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ChangeRegionalDialogData,
    private fb: FormBuilder,
    private formHelper: FormHelperService,
    private partnerService: PartnerService,
    private snack: MatSnackBar,
    private dialog: MatDialog,
  ) {
    this.partnerObject = data.partnerObject;
    this.changeRegionalForm = fb.group({
      changeAssetsRegional: this.changeAssetsRegionalControl = fb.control(false),
      changeLifeRegional: this.changeLifeRegionalControl = fb.control(false),
      assetsRegional: this.assetsRegionalControl = fb.control(''),
      lifeRegional: this.lifeRegionalControl = fb.control(''),
      changeOfwca: this.changeOfwcaControl = fb.control(false),
      changeOfwcaIfNotSame: this.changeOfwcaIfNotSameControl = fb.control(false),
    });
    this.assetsRegionalControl.disable();
    this.lifeRegionalControl.disable();
  }

  ngOnInit(): void {
    this.changeAssetsRegionalControl.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe((val: boolean) => {
        if (!val) {
          this.assetsRegionalControl.disable();
        } else {
          this.assetsRegionalControl.enable();
        }
      });

    this.changeLifeRegionalControl.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe((val: boolean) => {
        if (!val) {
          this.lifeRegionalControl.disable();
        } else {
          this.lifeRegionalControl.enable();
        }
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  sendForm(): void {
    this.processingRequest = true;
    this.formHelper.removeBackendErrorState(this.changeRegionalForm, this.formErrors);
    this.formErrors = {};

    this.partnerService.changeRegional(this.changeRegionalForm.value, this.partnerObject.uuid)
      .subscribe((response: Uuid) => {
        const dialogRef = this.dialog.open(JobResultDialogComponent, {
          disableClose: true,
          width: '500px',
          data: {jobId: response.uuid, showProgress: false},
        });

        dialogRef.afterClosed().subscribe(result => {
          this.snack.open('Pomyślnie zaktualizowano obiekt partnera', '', {
            duration: 2000,
          });
          this.processingRequest = false;
          this.dialogRef.close();
        });
      }, (error: HttpErrorResponse) => {
        this.processingRequest = false;

        this.snack.open('Podczas aktualizacji obiektu partnera wystąpił błąd', error.status.toString(), {
          duration: 2000,
        });

        if (error.status === 400) {
          this.formErrors = error.error.error.list;
          this.formHelper.setBackendErrorState(this.changeRegionalForm, this.formErrors);
        }
      })
    ;
  }
}
